import Shell from '../features/navigation/layouts/shell';

export default function ShellPage() {
    return <Shell />;
}
